import { _ as l } from "./extends-0a3e0827.js";
import { _ as E } from "./objectWithoutPropertiesLoose-1e2b28af.js";
import { i as W, s as z } from "./extendSxProp-10687d60.js";
import { a as I, b as q, s as B, i as G } from "./createTheme-ef7fa3a1.js";
import { g as H } from "./styled-a6aa6ca0.js";
const J = ["ownerState"], K = ["variants"], Q = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function U(e) {
  return Object.keys(e).length === 0;
}
function X(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function A(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Y = I(), b = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function w({
  defaultTheme: e,
  theme: i,
  themeId: o
}) {
  return U(i) ? e : i[o] || i;
}
function Z(e) {
  return e ? (i, o) => o[e] : null;
}
function x(e, i) {
  let {
    ownerState: o
  } = i, p = E(i, J);
  const u = typeof e == "function" ? e(l({
    ownerState: o
  }, p)) : e;
  if (Array.isArray(u))
    return u.flatMap((h) => x(h, l({
      ownerState: o
    }, p)));
  if (u && typeof u == "object" && Array.isArray(u.variants)) {
    const {
      variants: h = []
    } = u;
    let m = E(u, K);
    return h.forEach((t) => {
      let s = !0;
      typeof t.props == "function" ? s = t.props(l({
        ownerState: o
      }, p, o)) : Object.keys(t.props).forEach((d) => {
        (o == null ? void 0 : o[d]) !== t.props[d] && p[d] !== t.props[d] && (s = !1);
      }), s && (Array.isArray(m) || (m = [m]), m.push(typeof t.style == "function" ? t.style(l({
        ownerState: o
      }, p, o)) : t.style));
    }), m;
  }
  return u;
}
function se(e = {}) {
  const {
    themeId: i,
    defaultTheme: o = Y,
    rootShouldForwardProp: p = A,
    slotShouldForwardProp: u = A
  } = e, h = (a) => B(l({}, a, {
    theme: w(l({}, a, {
      defaultTheme: o,
      themeId: i
    }))
  }));
  return h.__mui_systemSx = !0, (a, m = {}) => {
    W(a, (n) => n.filter((f) => !(f != null && f.__mui_systemSx)));
    const {
      name: t,
      slot: s,
      skipVariantsResolver: d,
      skipSx: j,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: F = Z(b(s))
    } = m, T = E(m, Q), $ = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      s && s !== "Root" && s !== "root" || !1
    ), D = j || !1;
    let k;
    process.env.NODE_ENV !== "production" && t && (k = `${t}-${b(s || "Root")}`);
    let v = A;
    s === "Root" || s === "root" ? v = p : s ? v = u : X(a) && (v = void 0);
    const O = z(a, l({
      shouldForwardProp: v,
      label: k
    }, T)), C = (n) => typeof n == "function" && n.__emotion_real !== n || G(n) ? (f) => x(n, l({}, f, {
      theme: w({
        theme: f.theme,
        defaultTheme: o,
        themeId: i
      })
    })) : n, P = (n, ...f) => {
      let R = C(n);
      const y = f ? f.map(C) : [];
      t && F && y.push((r) => {
        const c = w(l({}, r, {
          defaultTheme: o,
          themeId: i
        }));
        if (!c.components || !c.components[t] || !c.components[t].styleOverrides)
          return null;
        const S = c.components[t].styleOverrides, _ = {};
        return Object.entries(S).forEach(([L, M]) => {
          _[L] = x(M, l({}, r, {
            theme: c
          }));
        }), F(r, _);
      }), t && !$ && y.push((r) => {
        var c;
        const S = w(l({}, r, {
          defaultTheme: o,
          themeId: i
        })), _ = S == null || (c = S.components) == null || (c = c[t]) == null ? void 0 : c.variants;
        return x({
          variants: _
        }, l({}, r, {
          theme: S
        }));
      }), D || y.push(h);
      const V = y.length - f.length;
      if (Array.isArray(n) && V > 0) {
        const r = new Array(V).fill("");
        R = [...n, ...r], R.raw = [...n.raw, ...r];
      }
      const N = O(R, ...y);
      if (process.env.NODE_ENV !== "production") {
        let r;
        t && (r = `${t}${q(s || "")}`), r === void 0 && (r = `Styled(${H(a)})`), N.displayName = r;
      }
      return a.muiName && (N.muiName = a.muiName), N;
    };
    return O.withConfig && (P.withConfig = O.withConfig), P;
  };
}
export {
  se as c,
  A as s
};
//# sourceMappingURL=createStyled-4c27adb8.js.map
